import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// Self-hosted typefaces. Must load before the stylesheets that reference them.
import "./styles/fonts";
// Pulls in every palette/form/layout stylesheet automatically.
import "./appearance/styles";
import "./styles/base.css";
import App from "./App";

const container = document.getElementById("root");
if (!container) {
  throw new Error('Root element "#root" is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
